import axios from 'axios';

export default async function getCanales(channelCode) {
  let path= "https://zapp-1782-claro-sports.web.app/nielsen/stations/";
  let params= "/airings?hourOffset=10";

    try {
      const response = await axios.get(`${path}${channelCode}${params}`);
      return response.data;
    } catch (error) {
      console.error('Error al cargar el JSON:', error);
      throw error;
    }
  }
  